import React from 'react';

import {Layout, Menu} from 'antd';
import {NavLink} from 'react-router-dom';
const {Header} = Layout;

import classes from './MainHeader.module.css';

const MainHeader = (props) => {
  const currentPage = props.currentUrl[0] || 'home';
  return (
    <Header style={{padding: 0}}>
      <nav className={classes.nav}>
        <div className={classes.logo}>
          <img src={process.env.PUBLIC_URL + '/logo.svg'}/>
        </div>
        <Menu theme="dark" mode="horizontal" selectedKeys={[currentPage]}>
          <Menu.Item key="home">
            <NavLink to='/'>
          Accueil
            </NavLink>
          </Menu.Item>
          <Menu.Item key="albums">
            <NavLink to='/albums'>
          Albums
            </NavLink>
          </Menu.Item>
          {/* <Menu.Item key="contact">
            <NavLink to='/contact'>
      Contact
            </NavLink>
          </Menu.Item> */}
        </Menu>
      </nav>
    </Header>
  );
};

export default MainHeader;
